import { createSelector } from "@reduxjs/toolkit";
import { rootState } from "../../../../redux/store";

export const selectorChatbot = createSelector(
    (state: rootState) => state.loginUserAndTokenData,
    (state: rootState) => state.chat,
    (state: rootState) => state.chatHistory,


    (loginUserAndTokenData, chat, chatHistory) => {
        return  {
            loginUserAndTokenData,
            chat,
            chatHistory,
        }
    }
);